import React from 'react'

export const matchImageTourConfig = (t) => ({
    id: 'match-image-generation',
    name: t('tour:match_image_generation_name'),
    description: t('tour:match_image_generation_desc'),
    icon: 'picture',
    steps: [
        {
            target: '[data-tour="expand-icon"]',
            title: t('tour:match_image_generation_step_0_title'),
            content: (
                <div>
                    <p>{t('tour:match_image_generation_step_0_content')}</p>
                </div>
            ),
            placement: 'right',
            disableNextInitially: true
        },
        {
            target: '[data-tour="matchImage"]',
            title: t('tour:match_image_generation_step_1_title'),
            content: (
                <div>
                    <p>{t('tour:match_image_generation_step_1_content_prefix')} <strong>{t('tour:match_image_generation_step_1_content_bold')}</strong> {t('tour:match_image_generation_step_1_content_suffix')}</p>
                </div>
            ),
            placement: 'right',
            disableNextInitially: true
        },
        {
            target: '[data-tour="page-preview"]',
            title: t('tour:match_image_generation_step_2_title'),
            content: (
                <div>
                    <p>{t('tour:match_image_generation_step_2_content')}</p>
                </div>
            ),
            placement: 'left',
            disableNextInitially: true
        },
        {
            target: '[data-tour="create-content-button"]',
            title: t('tour:match_image_generation_step_3_title'),
            content: (
                <div>
                    <p>{t('tour:match_image_generation_step_3_content_prefix')} <strong>{t('tour:match_image_generation_step_3_content_bold')}</strong> {t('tour:match_image_generation_step_3_content_suffix')}</p>
                </div>
            ),
            placement: 'top',
            disableNextInitially: true
        },
        {
            target: '.match-image-modal',
            title: t('tour:match_image_generation_step_4_title'),
            content: (
                <div>
                    <p>{t('tour:match_image_generation_step_4_content')}</p>
                </div>
            ),
            placement: 'center',
            waitFor: '.match-image-modal'
        },
        {
            target: '[data-tour="generate-match-image-btn"]',
            title: t('tour:match_image_generation_step_5_title'),
            content: (
                <div>
                    <p>{t('tour:match_image_generation_step_5_content_prefix')} <strong>{t('tour:match_image_generation_step_5_content_bold')}</strong> {t('tour:match_image_generation_step_5_content_suffix')}</p>
                </div>
            ),
            placement: 'top'
        }
    ]
})
